/* TODO: have this be unit tested */

import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '~/utils';
import { DATE_TIME_FORMAT } from '~/utils/consts';

const TableCellDateTime = ({
  value,
  format: f,
  emptyValue,
}) => (
  <div>{formatDate(value, f, emptyValue)}</div>
);

TableCellDateTime.propTypes = {
  value: PropTypes.string.isRequired,
  format: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      in: PropTypes.string,
      out: PropTypes.string,
    }),
  ]),
  emptyValue: PropTypes.string,
};

TableCellDateTime.defaultProps = {
  format: DATE_TIME_FORMAT,
  emptyValue: '',
};

export default TableCellDateTime;
